import React, { useState, useEffect, useCallback } from "react";
import {
  Card,
  CardContent,
  Grid,
  Typography,
  Button,
  FormHelperText,
} from "@mui/material";
import { Delete as DeleteIcon, Send as SendIcon } from "@mui/icons-material";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Form } from "react-final-form";

import { Select, TextField } from "../common/Fields";
import { Content } from "../layout";
import {
  fetchRepeaters,
  getDetector,
  submitDetector,
  updateDetector,
  deleteDetector,
} from "../../actions";

const DetectorForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const { detector } = useSelector((state) => state.detector);
  const repeaters = useSelector((state) => state.repeater.repeaters.rows);
  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(fetchRepeaters({}));
    if (id) {
      dispatch(getDetector(id));
    }
  }, [id, user, dispatch]);

  const onSubmit = useCallback(
    async (detector) => {
      const upsertDetector = new Promise((resolve, reject) => {
        if (id) {
          dispatch(updateDetector({ detector, id }))
            .then(() => resolve())
            .catch((error) => reject(error));
        } else {
          dispatch(submitDetector({ detector }))
            .then(() => resolve())
            .catch((error) => reject(error));
        }
      });

      try {
        await upsertDetector;
        navigate("/detectors");
      } catch (error) {
        let errors;
        if (error.response.data?.errors) {
          const arrayErrors = error.response.data.errors;
          arrayErrors.forEach((error) => {
            errors = { ...errors, [error.param]: error.msg };
          });
        }
        return errors;
      }
    },
    [id, dispatch, navigate]
  );

  const onDelete = useCallback(
    async (e) => {
      e.preventDefault();
      if (window.confirm("삭제하시겠습니까?")) {
        dispatch(deleteDetector({ id }))
          .then(() => navigate("/detectors"))
          .catch((error) => alert(error));
      }
    },
    [id, dispatch, navigate]
  );

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={{
        RepeaterDevEUI: detector?.RepeaterDevEUI,
        chipID: detector?.chipID,
        name: detector?.name,
      }}
      validate={({ RepeaterDevEUI, chipID, name }) => {
        const errors = {};
        if (!RepeaterDevEUI) {
          errors.RepeaterDevEUI = "필수";
        }
        if (!chipID) {
          errors.chipID = "필수";
        } else if (!Number.isInteger(parseInt(chipID))) {
          errors.chipID = "숫자로 입력해주세요";
        }
        if (!name) {
          errors.name = "필수";
        }
        return errors;
      }}
      render={({
        submitError,
        handleSubmit,
        form,
        submitting,
        pristine,
        values,
      }) => (
        <Content>
          <form onSubmit={handleSubmit}>
            <Card>
              <CardContent>
                <Typography variant="h5" component="div">
                  감지기
                </Typography>
                <Grid
                  container
                  alignItems="flex-start"
                  spacing="20"
                  sx={{ mt: 2 }}
                >
                  <Grid item xs={12}>
                    <Select
                      name="RepeaterDevEUI"
                      label="리피터"
                      variant="standard"
                      data={repeaters}
                      dataKey="devEUI"
                      dataValue="name"
                      // disabled={id ? true : false}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      variant="standard"
                      name="chipID"
                      type="text"
                      label="칩 ID"
                      helperText="숫자만 입력할 수 있습니다."
                      inputProps={{
                        pattern: "^\\d+$",
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      variant="standard"
                      name="name"
                      type="text"
                      label="감지기명"
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            {submitError && <FormHelperText>{submitError}</FormHelperText>}
            <Grid container sx={{ mt: 2 }}>
              <Grid item xs={6}>
                {id && (
                  <Button
                    variant="outlined"
                    color="error"
                    startIcon={<DeleteIcon />}
                    onClick={onDelete}
                  >
                    삭제
                  </Button>
                )}
              </Grid>
              <Grid item xs={6} container justifyContent="flex-end">
                <Button
                  variant="contained"
                  endIcon={<SendIcon />}
                  type="submit"
                >
                  저장
                </Button>
              </Grid>
            </Grid>
          </form>
        </Content>
      )}
    />
  );
};

export default DetectorForm;
